var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_910_3444",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: -3,
    width: 75,
    height: 150
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 -3C81.8491 -3 91.6018 -1.06007 100.701 2.70904C109.801 6.47814 118.069 12.0026 125.033 18.967C131.997 25.9314 137.522 34.1993 141.291 43.2988C145.06 52.3982 147 62.1509 147 72C147 81.8492 145.06 91.6019 141.291 100.701C137.522 109.801 131.997 118.069 125.033 125.033C118.069 131.997 109.801 137.522 100.701 141.291C91.6018 145.06 81.8491 147 71.9999 147L72 72V-3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_910_3444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.461 56.2493H62.9049L76.0897 33.4126C79.7559 33.8012 83.3799 34.7137 86.8475 36.1501C96.0531 39.9631 103.427 47.1656 107.461 56.2493Z",
    fill: "#C2CCDE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.37 94.8356L81.0916 56.2489L107.461 56.2493C108.958 59.6187 109.979 63.213 110.469 66.9342C111.77 76.813 109.219 86.8002 103.37 94.8356Z",
    fill: "#C2CCDE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9075 110.585L90.1855 71.9986L103.37 94.8356C101.2 97.8163 98.5984 100.498 95.6207 102.783C87.7157 108.849 77.7912 111.634 67.9075 110.585Z",
    fill: "#C2CCDE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5362 87.7492L81.0923 87.7492L67.9075 110.585C64.2412 110.197 60.6174 109.285 57.1497 107.848C47.9441 104.035 40.5702 96.8329 36.5362 87.7492Z",
    fill: "#C2CCDE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6276 49.1627L62.9056 87.7494L36.5362 87.7492C35.0397 84.3798 34.0178 80.7854 33.5279 77.0641C32.2274 67.1854 34.7779 57.1981 40.6276 49.1627Z",
    fill: "#C2CCDE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0897 33.4126L53.8116 71.9997L40.6276 49.1627C42.7973 46.182 45.3987 43.5001 48.3764 41.2152C56.2814 35.1495 66.206 32.3643 76.0897 33.4126Z",
    fill: "#C2CCDE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.461 56.2493H62.9049L76.0897 33.4126M107.461 56.2493C103.427 47.1656 96.0531 39.9631 86.8475 36.1501C83.3799 34.7137 79.7559 33.8012 76.0897 33.4126M107.461 56.2493L81.0916 56.2489L103.37 94.8356M107.461 56.2493C108.958 59.6187 109.979 63.213 110.469 66.9342C111.77 76.813 109.219 86.8002 103.37 94.8356M76.0897 33.4126L53.8116 71.9997L40.6276 49.1627M76.0897 33.4126C66.206 32.3643 56.2814 35.1495 48.3764 41.2152C45.3987 43.5001 42.7973 46.182 40.6276 49.1627M103.37 94.8356L90.1855 71.9987L67.9075 110.585M103.37 94.8356C101.2 97.8163 98.5984 100.498 95.6207 102.783C87.7157 108.849 77.7912 111.634 67.9075 110.585M67.9075 110.585L81.0923 87.7492L36.5362 87.7492M67.9075 110.585C64.2412 110.197 60.6174 109.285 57.1497 107.848C47.9441 104.035 40.5702 96.8329 36.5362 87.7492M36.5362 87.7492L62.9056 87.7494L40.6276 49.1627M36.5362 87.7492C35.0397 84.3798 34.0178 80.7854 33.5279 77.0641C32.2274 67.1854 34.7779 57.1981 40.6276 49.1627",
    stroke: "#C2CCDE",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.462 56.2494H62.9054L76.0902 33.4127C79.7564 33.8014 83.3804 34.7138 86.848 36.1502C96.0536 39.9633 103.427 47.1658 107.462 56.2494Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.37 94.8357L81.0921 56.2491L107.462 56.2494C108.958 59.6188 109.98 63.2131 110.47 66.9343C111.77 76.8131 109.22 86.8004 103.37 94.8357Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.908 110.585L90.186 71.9988L103.37 94.8357C101.2 97.8165 98.5989 100.498 95.6212 102.783C87.7162 108.849 77.7917 111.634 67.908 110.585Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5367 87.7493L81.0928 87.7493L67.908 110.585C64.2417 110.197 60.6178 109.285 57.1502 107.849C47.9446 104.035 40.5707 96.833 36.5367 87.7493Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6281 49.1629L62.9061 87.7495L36.5367 87.7493C35.0401 84.38 34.0183 80.7855 33.5284 77.0643C32.2278 67.1855 34.7784 57.1982 40.6281 49.1629Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0902 33.4127L53.8121 71.9998L40.6281 49.1629C42.7978 46.1821 45.3992 43.5002 48.3769 41.2153C56.2819 35.1496 66.2065 32.3644 76.0902 33.4127Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.462 56.2494H62.9054L76.0902 33.4127M107.462 56.2494C103.427 47.1658 96.0536 39.9633 86.848 36.1502C83.3804 34.7138 79.7564 33.8014 76.0902 33.4127M107.462 56.2494L81.0921 56.2491L103.37 94.8357M107.462 56.2494C108.958 59.6188 109.98 63.2131 110.47 66.9343C111.77 76.8131 109.22 86.8004 103.37 94.8357M76.0902 33.4127L53.8121 71.9998L40.6281 49.1629M76.0902 33.4127C66.2065 32.3644 56.2819 35.1496 48.3769 41.2153C45.3992 43.5002 42.7978 46.1821 40.6281 49.1629M103.37 94.8357L90.186 71.9988L67.908 110.585M103.37 94.8357C101.2 97.8165 98.5989 100.498 95.6212 102.783C87.7162 108.849 77.7917 111.634 67.908 110.585M67.908 110.585L81.0928 87.7493L36.5367 87.7493M67.908 110.585C64.2417 110.197 60.6178 109.285 57.1502 107.849C47.9446 104.035 40.5707 96.833 36.5367 87.7493M36.5367 87.7493L62.9061 87.7495L40.6281 49.1629M36.5367 87.7493C35.0401 84.38 34.0183 80.7855 33.5284 77.0643C32.2278 67.1855 34.7784 57.1982 40.6281 49.1629",
    stroke: "#007BFF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9985 29.9992L108.372 50.9992V92.9992L71.9985 113.999L35.6254 92.9992V50.9992L71.9985 29.9992Z",
    stroke: "#007BFF",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.25 5.62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5908 68.4591L63.6853 2.55139L86.4248 15.6654L48.3303 81.573L25.5908 68.4591Z",
    stroke: "#007BFF",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.25 5.62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8607 30.0392L127.986 30.0761L127.998 56.3261L51.8735 56.2892L51.8607 30.0392Z",
    stroke: "#007BFF",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.25 5.62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2689 33.579L136.299 99.5236L113.573 112.66L75.5421 46.715L98.2689 33.579Z",
    stroke: "#007BFF",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.25 5.62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.167 75.1608L80.1041 141.087L57.3709 127.962L95.4334 62.0358L118.167 75.1608Z",
    stroke: "#007BFF",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.25 5.62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.137 113.959L16.012 113.922L15.9992 87.6724L92.1242 87.7093L92.137 113.959Z",
    stroke: "#007BFF",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.25 5.62"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7287 110.42L7.69824 44.4749L30.425 31.3388L68.4555 97.2835L45.7287 110.42Z",
    stroke: "#007BFF",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.25 5.62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.4fa4b237c35d2995a30d8a01a072414d.svg";
export { ForwardRef as ReactComponent };